export default "__VITE_ASSET__D6zkpD7M__"